module.exports = __webpack_public_path__ + "static/media/orcid.4af46c0c.svg";